module.exports = __webpack_public_path__ + "static/img/kapian_b.eb6e476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/businessTicketDiscount/kapian_b.png
// module id = dsTP
// module chunks = 70